<div class="notifications-container">
  <i (click)="viewNotifications()"
     [attr.data-count]="notificationCount"
     [class.badge]="activateBell && notificationCount > 0"
     [class.icon-red]="activateBell && notificationCount > 0" class="pi pi-bell icon-buttons"
     id="app-icon-notification"></i>
</div>
